import React from 'react';
import { round_to, useHover } from '../utils';

const scale = (v, factor, precision) => round_to(v / factor, precision);

const Dots = ({ active, chart_height, onClick, round, max }) => {
  const factor = 6;
  const max_radius = scale(max, factor, 2);
  const min_radius = 4;

  const filtered = active.slice(0, 6);
  const dots = filtered.map(({ color, label, raw, value, id }, index) => {
    const r = scale(raw, factor, 2);
    const radius = r <= 0 ? min_radius : r;
    const circle_x = round_to((index + 1) * (max_radius * 1.7), 2);
    const circle_y = round_to(chart_height / 2, 2);

    return (
      <g key={id}>
        <circle
          style={{ cursor: 'pointer' }}
          onClick={() => onClick({ raw, label })}
          cx={circle_x}
          cy={circle_y}
          r={radius}
          fill={color}
        />
      </g>
    );
  });

  return (
    <g
      aria-hidden="true"
      strokeLinecap={round ? 'round' : 'butt'}
      strokeLinejoin={round ? 'round' : 'miter'}
    >
      {dots}
    </g>
  );
};
export default Dots;
